exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".query_b4a5f98{display:flex;flex-direction:row}.query_b4a5f98>div{width:100%!important}.query_item_f160577{width:48%!important}.tableW_b4a6252{width:100%}.preview_e98b9b7{cursor:pointer;color:#1890ff}.wordStyle_473c463{word-break:break-all}", ""]);

// exports
exports.locals = {
	"query": "query_b4a5f98",
	"query_item": "query_item_f160577",
	"tableW": "tableW_b4a6252",
	"preview": "preview_e98b9b7",
	"wordStyle": "wordStyle_473c463"
};